// Error Validation for redux form
const validate = values => {
  const errors = {}
  return errors
}

export default validate